<template>
    <div class="page orders">
        <div class="contain orders">
            <h1>Orders</h1>
            <div class="filters">
                <input
                    type="text"
                    placeholder="Search by order number, event or buyer."
                    class="search filter"
                    v-model="query"
                    @input="this.handleFilter"
                />
                <select
                    id="date-filter"
                    name="date-filter"
                    class="date filter"
                    v-model="selectedDateOption"
                    @change="onDateFilterChange()"
                >
                    <option
                        v-for="(option, i) in date_filter_options"
                        :key="i"
                        :value="option.value"
                        >{{ option.label }}</option
                    >
                </select>
            </div>
            <table class="orders">
                <thead>
                    <td>Order</td>
                    <td>Event</td>
                    <td>Buyer</td>
                    <td>Date</td>
                    <td>Total</td>
                </thead>

                <tbody>
                    <tr
                        v-for="(order, id) in orders"
                        @click="goTo('/event/' + order.event.id + '/orders')"
                        :key="id"
                    >
                        <td>#{{ order.order_number }}</td>
                        <td>{{ order.event.title }}</td>
                        <td>{{ order.buyer }}</td>
                        <td>{{ order.created_at | format_date_time }}</td>
                        <td>${{ order.total_cost }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase';
import moment from 'moment';

const fb = require('../firebaseConfig.js');
const db = fb.default.db;

export default {
    name: 'orders',
    components: {},
    data() {
        return {
            orders: [],
            date_filter_options: [
                { label: 'All', value: 0 },
                { label: 'Past 3 months', value: 3 },
                { label: 'Past 6 months', value: 6 },
                { label: 'Past 12 months', value: 12 },
            ],
            query: '',
            filtered_orders: [],
            selectedDateOption: 0,
        };
    },
    created() {
        this.getOrders();
    },
    methods: {
        getOrders() {
            return db
                .collection('user')
                .doc(this.$store.state.user.uid)
                .collection('orders')
                .orderBy('created_at', 'desc')
                .get()
                .then((snapshot) => {
                    this.orders = snapshot.docs.map((doc) => {
                        return Object.assign({ id: doc.id }, doc.data());
                    });
                });
        },
        handleFilter() {
            if (this.query && this.orders.length) {
                let query = this.query.toLowerCase();
                let filtered_orders = this.orders.filter((order) => {
                    if (
                        order.buyer.toLowerCase().includes(query) ||
                        order.order_number
                            .toString()
                            .toLowerCase()
                            .includes(query) ||
                        order.event.title.toLowerCase().includes(query)
                    ) {
                        return order;
                    }
                });
                this.orders = filtered_orders;
            } else {
                return this.getOrders();
            }
        },
        onDateFilterChange() {
            if (this.selectedDateOption && this.orders.length) {
                let now = moment();
                let pastXMonths = moment().subtract(
                    this.selectedDateOption,
                    'months'
                );
                let filtered_orders = this.orders.filter((order) => {
                    let orderDate = moment(order.created_at);
                    if (orderDate.isBetween(pastXMonths, now, 'months', true)) {
                        return order;
                    }
                });
                this.orders = filtered_orders;
            } else {
                return this.getOrders();
            }
        },
    },
};
</script>

<style lang="scss">
.orders {
    width: 100%;
    border-collapse: collapse;

    thead {
        background-color: #efefef;

        td {
            padding: 10px;
        }
    }

    tbody {
        td {
            padding: 20px 10px;
            border-bottom: 1px solid #eaeaea;
            background-color: transparent;
        }

        tr {
            background-color: white;
            transition: background-color 0.3s;
            cursor: pointer;

            &:hover {
                background-color: #f7f7f7;
            }
        }
    }
}
.filters {
    display: flex;
    flex-direction: row;
    margin-top: 24px;
    margin-bottom: 10px;
}
.search {
    width: 33%;
}
#date-filter {
    background-color: white;
    border: none;
    outline: none;
    padding: 10px 15px;
    font-size: 17px;
    color: #0d0d0d;
    width: 25%;
    box-shadow: 0 0 8px rgba(128, 128, 128, 0.2);
    margin-left: 8px;
}
</style>
